<template>
</template>

<script>
import estimatesPrintHTML from '@/views/sales/estimates/SalesEstimatesPrintHTML'
import printHtml from '@/mixins/printHtml'

export default {
  name: 'SalesEstimatesPrint',
  mixins: [estimatesPrintHTML,printHtml],
  props: {
    estimate: {type:Object, required:false},
    estimates: {type:Array, required:false}
  },
  data() {
    return {
      company: null,
    }
  },
  async created() {
    this.$emit('done');
    const results = await this.$apiCall(`query SalesEstimatesPrint {
                                            company {name,address,city,province,postalCode,email,phone,logoURL}
                                          }`,
                                        {});
    if (results.error)
      return;
    this.company = results.data.company;

    const lines = [];
    const logos = this.company.logoURL ? [] : null;
    const estimates = this.estimate ? [this.estimate] : this.estimates;
    let n = estimates.length - 1;
    for (const estimate of estimates) {
      lines.push(await this.printEstimate(estimate.id));
      if (n--)
        lines.push(`<div class="page-break"/>`);
      if (logos)
        logos.push({id:estimate.id, src:this.company.logoURL});
    }
    this.printHtml(`Sales estimate ${this.estimate?this.estimate.number:''}`, lines.join(''), logos);
  },
  methods: {
    async printEstimate(id) {
      const results = await this.$apiCall(`query SalesEstimatesPrint($id:ID!) {
                                            estimate(id:$id) {
                                              id,date,expires,number,shipToAddress,billToAddress,memo,taxInclusive
                                              salesRepName
                                              lines {
                                                sku,description,taxCodeId,quantity,units,unitPrice,amount,precision
                                                items {sku,description,quantity,units,precision}
                                              }
                                              taxLines {
                                                  id,name,amount,onAmount,percent
                                                }
                                                discount {percent,amount,value}
                                            }
                                            }`,
                                          {id});
      if (results.error)
        return;
      const estimate = results.data.estimate;
      return this.print(this.company, estimate);
    }
  }
}
</script>